import { Inject } from '@odinjs/odin';

import { FetchAPI, FormAPI } from '@philips-emr/tws-components';
import Controller, { OnCancel, OnMount, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { AuthenticationService, HttpService, ModalService } from '@philips-emr/tws-core/lib/services';

import { AditivoContratualDetalhesAliases as Aliases, FragmentNames, RootRoutes } from '../codegen';
import { Endpoints } from '../definitions/endpoints';
import ContractAmendmentService from '../services/contract-amendment-service';

import BaseController from './base/base-controller';

@Controller({ fragment: FragmentNames.ADITIVO_CONTRATUAL_DETALHES })
class AditivoContratualDetalhesController extends BaseController {

  @Inject(Aliases.FORM_ADITIVO)
  private formAditivo: FormAPI;

  @OnMount(Aliases.FETCH_ADITIVO)
  onMountFetch(event: MountEvent): void {
    const { nrSeqBeneficiario } = this.historyService.getCurrentRouteParams();
    const { nrSeqTermo } = this.context.getBulkData();
    const api = event.target as FetchAPI;
    api.setParameters({ nrSeqBeneficiario, nrSeqTermo });
    api.forceFetch();
  }

  @OnCancel(Aliases.FORM_ADITIVO)
  onCancelAditivo(): void {
    const { ieObrigatorio } = this.formAditivo.getRecord();
    const { nrSeqBeneficiario } = this.historyService.getCurrentRouteParams();
    const { nrSeqSegurado, nrSeqTermo } = this.formAditivo.getRecord();
    const data = {
      nrSeqSegurado,
      nrSeqTermo,
      ieStatus: 'R',
      nrSeqSeguradoAceite: nrSeqBeneficiario,
    };

    if (ieObrigatorio == 'S') {
      void AuthenticationService.logout().then(() => {
        this.historyService.push(RootRoutes.ROUTE_LOGIN);
      });
    } else {
      void HttpService.post(Endpoints.POST.RECUSAR_ADITIVO_CONTRATUAL, { nrSeqBeneficiario }, { body: data }).then(() => {
        ModalService.close('amendment-modal');
      });

    }
  }

  @OnSubmit(Aliases.FORM_ADITIVO)
  onAcceptAmendment(): void {
    const { nrSeqBeneficiario } = this.historyService.getCurrentRouteParams();
    const { nrSeqSegurado, nrSeqTermo } = this.formAditivo.getRecord();
    const data = {
      nrSeqSegurado,
      nrSeqTermo,
      ieStatus: 'C',
      nrSeqSeguradoAceite: nrSeqBeneficiario,
    };

    if (nrSeqTermo) {
      void HttpService.post(Endpoints.POST.CHECK_ADITIVO_CONTRATUAL, { nrSeqBeneficiario }, { body: data }).then(() => {
        ModalService.close('amendment-modal');
        ContractAmendmentService.checkAmends(nrSeqBeneficiario as string);
      });

    }
  }
}

export default AditivoContratualDetalhesController;
